module.exports = __webpack_public_path__ + "static/media/dw3.5d88da3f.png";